const map = {
	"./play-da-DK@2x.png": 3267,
	"./play-de@2x.png": 78161,
	"./play-en@2x.png": 77053,
	"./play-es@2x.png": 75086,
	"./play-fr@2x.png": 35114,
	"./play-it@2x.png": 43135,
	"./play-nl@2x.png": 9676,
	"./play-no@2x.png": 38089,
	"./play-sv@2x.png": 64683
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23180;